import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  onReset,
  technicians,
  serviceTypes 
}) => {
  const urgencyOptions = [
    { value: 'all', label: 'Toutes les urgences' },
    { value: 'urgent', label: 'Urgent' },
    { value: 'today', label: "Aujourd\'hui" },
    { value: 'scheduled', label: 'Planifié' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'planned', label: 'Planifié' },
    { value: 'en_route', label: 'En route' },
    { value: 'on_site', label: 'Sur place' },
    { value: 'completed', label: 'Terminé' }
  ];

  const technicianOptions = [
    { value: 'all', label: 'Tous les techniciens' },
    ...technicians?.map(tech => ({
      value: tech?.id,
      label: tech?.name
    }))
  ];

  const serviceTypeOptions = [
    { value: 'all', label: 'Tous les services' },
    ...serviceTypes?.map(type => ({
      value: type?.value,
      label: type?.label
    }))
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-foreground">Filtres</h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          onClick={onReset}
        >
          Réinitialiser
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Urgence"
          options={urgencyOptions}
          value={filters?.urgency}
          onChange={(value) => onFilterChange('urgency', value)}
        />

        <Select
          label="Statut"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Technicien"
          options={technicianOptions}
          value={filters?.technician}
          onChange={(value) => onFilterChange('technician', value)}
          searchable
        />

        <Select
          label="Type de service"
          options={serviceTypeOptions}
          value={filters?.serviceType}
          onChange={(value) => onFilterChange('serviceType', value)}
          searchable
        />

        <Input
          label="Zone géographique"
          type="text"
          placeholder="Code postal ou ville"
          value={filters?.area}
          onChange={(e) => onFilterChange('area', e?.target?.value)}
        />

        <Input
          label="Recherche client"
          type="search"
          placeholder="Nom ou téléphone"
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default FilterPanel;